<template>
    <NavAndBody>
        <h1>Dashboard</h1>
        <p>t: {{authToken}}</p>
    </NavAndBody>
</template>

<script>
    import NavAndBody from '@/components/layout/NavAndBody';

    export default {
        name: 'Dashboard',
        components: {NavAndBody},
        computed: {
            authToken() {
                return this.$store.state.auth.authToken;
            },
        },
    };
</script>
